import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { withAuthUser } from 'components/common/withAuthUser';
import { withExternalBrowser } from 'components/common/withExternalBrowser';
import RescueTemplate from 'components/rescue/RescueTemplate';
import { ActionCtor } from 'store/modules/main';

const RescuePage = () => {
  const dispatch = useDispatch();
  const { room } = useParams();

  useEffect(() => {
    dispatch(ActionCtor.getRoom(room));
  }, []);

  return <RescueTemplate />;
};

export default withAuthUser(withExternalBrowser(RescuePage));
